import rebrandText from "@cvpartner/design-system/logos/mainWordmark.svg";
import rebrandLogo from "@cvpartner/design-system/logos/royalBlueIcon.svg";
import { mediaQuery } from "@cvpartner/design-system/vars";
import type * as React from "react";
import { useProgressBar } from "react-aria";
import { useMediaLayout } from "use-media";
import { useReadOrSaveInProgress } from "@/stores/NetworkState";
import { logo, logoIcon, spinner } from "./Logo.css";

const Loader: React.FC<{ loading: boolean }> = ({ loading }) => {
  const { progressBarProps } = useProgressBar({
    isIndeterminate: true,
    "aria-label": "Loading",
  });

  if (!loading) {
    return <span className={spinner({ loading: false })} />;
  }

  return <span {...progressBarProps} className={spinner({ loading: true })} />;
};

export const Logo: React.FC = () => {
  const loading = useReadOrSaveInProgress();
  const showLogoText = useMediaLayout(mediaQuery.m);

  return (
    <a href="/dashboard" className={logo}>
      <img
        className={logoIcon({ loading })}
        src={rebrandLogo}
        alt="Flowcase logo"
        aria-hidden={true}
      />
      <Loader loading={loading} />
      {showLogoText && <img src={rebrandText} alt="Flowcase" />}
    </a>
  );
};
